/**
 * Name of the category that represents the "Others" category.
 *
 * See `WidgetSource.getCategories` for more information.
 */
export const OTHERS_CATEGORY_NAME = '_carto_others';
